import { useLayoutEffect, useRef, type ReactNode } from "react";
import { useAuth } from "@bw/shared/hooks";
import { retireFinanceConnectActor } from "./lifecycle";

export function FinanceConnectIdentityBoundary({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();
  const previous = useRef<{ actor: string | null } | null>(null);
  const actor = user?.uid ?? null;
  useLayoutEffect(() => {
    if (loading) return;
    const before = previous.current;
    if (before?.actor && before.actor !== actor) retireFinanceConnectActor(before.actor);
    previous.current = { actor };
  }, [actor, loading]);
  return children;
}
